// extracted by mini-css-extract-plugin
module.exports = {"listTable":"LocalDataTable_listTable__YnvJj","barHolderIn":"LocalDataTable_barHolderIn__NJ1f1","sortColumn":"LocalDataTable_sortColumn__2GUNc"};